import { useQueryClient } from '@tanstack/react-query';
import { trpc } from '@/shared/api';
import { MY_REVIEWS_KEY, PRODUCT_REVIEWS_KEY } from './review-query-keys';

export interface InvalidateReviews {
  /** 작성·수정·삭제 뒤: 상품 요약·목록, 주문별 상태, 내 후기 목록·상세. 상품 id 를 모르면 요약 전체를 무효화한다. */
  readonly afterWrite: (productId?: string) => Promise<void>;
}

export const useInvalidateReviews = (): InvalidateReviews => {
  const utils = trpc.useUtils();
  const queryClient = useQueryClient();
  return {
    afterWrite: async (productId) => {
      await Promise.all([
        productId === undefined
          ? utils.reviews.summaryByProduct.invalidate()
          : utils.reviews.summaryByProduct.invalidate({ productId }),
        queryClient.invalidateQueries({ queryKey: [PRODUCT_REVIEWS_KEY] }),
        queryClient.invalidateQueries({ queryKey: [MY_REVIEWS_KEY] }),
        utils.myReviews.statesForOrders.invalidate(),
        utils.myReviews.get.invalidate(),
      ]);
    },
  };
};
